var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVodafoneLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(295.825 136.827)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(-295.825 -136.827)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M-219.119-89.063c-6.594.022-13.455-5.606-13.485-14.643a20.368,20.368,0,0,1,7.326-15.142,23.968,23.968,0,0,1,14.522-5.482,6.05,6.05,0,0,1,1.727.191,9.967,9.967,0,0,0-7.827,9.581,2.486,2.486,0,0,0,.029.391c7.308,1.78,10.625,6.189,10.646,12.291A12.843,12.843,0,0,1-219.119-89.063Z",
    transform: "translate(-52.516 -10.381)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVodafoneLogo);
export default __webpack_public_path__ + "static/media/vodafoneLogo.4dd85db7791882f36e1e2a21faf6eb89.svg";
export { ForwardRef as ReactComponent };